import { useMemo, useRef, useState } from 'react';
import { Skeleton } from 'antd';
import { TrackerCustomEvent, useTracker } from 'common-package';
import { SlideSelect } from '@/components';
import RFEffectRecord from './RFEffectRecord';
import ShockwaveEffectRecord from './ShockwaveEffectRecord';
import cx from './index.module.scss';

type SlideSelectTabsKey = 'terminal-function-scheme' | 'effect-record' | 'cave-details';

const DEFAULT_SELECT_STEPS = [
  { value: 'terminal-function-scheme', label: '末端功效示意' },
  { value: 'effect-record', label: '效果记录' },
  { value: 'cave-details', label: '穴区详情' },
];

const SpecificInfoRecord = ({
  serviceDetail,
  isGettingData,
  measurementData,
  questionnaireAnswer,
  refresh,
}: {
  isGettingData: boolean;
  serviceDetail: GetServiceOrderDetailResponse;
  measurementData?: GetMeasurementResultResponse;
  questionnaireAnswer?: GetActionTestQuestionnaireResponse;
  refresh?: VoidFunc;
}) => {
  const { sendEvent } = useTracker();
  const [currentTabKey, setCurrentTabKey] = useState<SlideSelectTabsKey>('terminal-function-scheme');
  const videoRef = useRef<HTMLVideoElement>(null);
  const hasShockWave = useMemo(() => serviceDetail?.itemType === 'Shockwave', [serviceDetail?.itemType]);

  const SlideSelectSteps = useMemo(() => {
    const itemType = serviceDetail?.itemType;
    if (itemType === 'Moxibustion' || itemType === 'HotStone') {
      return DEFAULT_SELECT_STEPS?.filter(item => item.value === 'terminal-function-scheme');
    } else if (itemType === 'Massage') {
      return DEFAULT_SELECT_STEPS?.filter(item => item.value !== 'effect-record');
    } else if (itemType === 'RadioFrequency' || itemType === 'Shockwave') {
      return DEFAULT_SELECT_STEPS?.filter(item => item.value !== 'cave-details');
    }
  }, [serviceDetail?.itemType]);

  return (
    <div
      className={cx('wrapper', {
        'extra-wrapper': currentTabKey === 'cave-details' && !!serviceDetail?.acupointsDisplay,
      })}
    >
      <Skeleton loading={isGettingData} paragraph={{ rows: 0 }} title={false}>
        <SlideSelect
          steps={SlideSelectSteps}
          value={currentTabKey}
          className={cx('slide-select')}
          onChange={value => {
            refresh();
            setCurrentTabKey(value as SlideSelectTabsKey);
            // 数据埋点
            if (value === 'effect-record') {
              sendEvent?.(TrackerCustomEvent.ViewMemberEffectRecordClk, {
                et: 'CLK',
              });
            }
          }}
        />
        <div className={cx('content')}>
          {currentTabKey === 'terminal-function-scheme' &&
            (serviceDetail?.effectDisplay ? (
              <video
                ref={videoRef}
                src={serviceDetail?.effectDisplay}
                className={cx('video')}
                poster={serviceDetail?.effectDisplayCoverImage}
                autoPlay
                loop
                muted
              />
            ) : (
              <div className={cx('video-wrapper')}>末端功效视频暂未配置</div>
            ))}

          {currentTabKey === 'cave-details' &&
            (serviceDetail?.acupointsDisplay ? (
              <div className={cx('acupoints-img')}>
                <img src={serviceDetail?.acupointsDisplay} alt="acupoints-img" />
              </div>
            ) : (
              <div className={cx('video-wrapper')}>穴区详情模型暂未配置</div>
            ))}

          {currentTabKey === 'effect-record' &&
            (hasShockWave ? (
              <ShockwaveEffectRecord questionnaireAnswer={questionnaireAnswer} />
            ) : (
              <RFEffectRecord serviceDetail={serviceDetail} measurementData={measurementData} />
            ))}
        </div>
      </Skeleton>
    </div>
  );
};

export default SpecificInfoRecord;
